import { useEffect, useState } from 'react';

// Eased 0→1 progress for count-up number animations. Restarts whenever
// `key` changes; stays at 0 while `active` is false (e.g. data still
// loading) so numbers animate in only once real values arrive.
export default function useCountUp(active, key, duration = 900) {
  const [prog, setProg] = useState(0);

  useEffect(() => {
    if (!active) {
      setProg(0);
      return undefined;
    }
    let raf;
    const t0 = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - t0) / duration);
      setProg(1 - Math.pow(1 - p, 3));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [active, key, duration]);

  return prog;
}
